module.exports = __webpack_public_path__ + "img/1462015242.752d20ce.jpg";